const twig = require('twig')
const APP = require('APP')
const trans = require('trans')
const router = require('router')
const numbers = require('numbers')

twig.extendFunction('asset', (value) => APP.assets[value] || value)

twig.extendFunction('path', router.path.bind(router))

twig.extendFilter('trans', (val, replaceObj = {}) => trans(val, replaceObj))

twig.extendFilter('money', (val, params = []) => numbers.money(val, ...params))

twig.extendFilter('format_datetime', (data) => data)
